import React, { useEffect, useState } from "react";
import "./activities.css";
import profileIc from "../../assets/png/profile-ic.png";
import ComposeModal from "./compose-modal";
import { Toast, ToastContainer } from "react-bootstrap";
import { getApi } from "../../services/http-clients";
import { set } from "date-fns";

export default function Activities({ vendorId }) {
  const LIMIT = 10;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [skip, setSkip] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showCompose, setShowCompose] = useState(false);
  const [itemOffset, setItemOffset] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [activities, setActivities] = useState([]);
  const handleSuccess = (response) => {
    console.log("Response from compose modal:", response);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setShowCompose(false);
      getActivityList();
    }
  };
  const handleLoadMore = () => {
    setLoading(true);
    const nextSkip = skip + LIMIT;
    setSkip(nextSkip);
    getActivityList(nextSkip);
  };

  const formatActivityTime = (dateTime) => {
    const date = new Date(dateTime.replace(" ", "T"));

    const today = new Date();
    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();

    const label = isToday ? "Today" : date.toLocaleDateString("en-IN");

    const time = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${label} , ${time}`;
  };

  const getActivityList = async (currentSkip = 0) => {
    const param = {
      limit: LIMIT,
      skip: currentSkip,
    };

    try {
      const data = await getApi(`${apiUrl}vendor/activity/${vendorId}`, param);
      if (data?.success) {
        setActivities((prev) =>
          currentSkip === 0 ? data.data || [] : [...prev, ...(data.data || [])],
        );
        setTotalCount(data.total_rec || 0);
        setPageCount(data.total_pgs || 0);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getActivityList();
  }, []);
  return (
    <div className="container-fluid px-4 py-3">
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <ComposeModal
        id={vendorId}
        show={showCompose}
        handleClose={() => setShowCompose(false)}
        succesError={handleSuccess}
      />
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bold mb-0">Activities</h5>

        <button
          className="btn compose-btn"
          onClick={() => setShowCompose(true)}
        >
          <span className="me-1">+</span> Compose
        </button>
      </div>

      {/* Activity Card */}
      {activities.length === 0 ? (
        <div className="text-center py-5 text-muted">
          <p className="fs-16 fw-500 mb-1">No activities found</p>
          <span className="fs-13 fw-400">Activities compiled from correspondence and meetings will appear here.</span>
        </div>
      ) : (
        activities.map((activity, index) => (
          <div className="activity-wrapper mb-2" key={index}>
            <div className="activity-time">
              {formatActivityTime(activity.created_at)}
            </div>

            <div className="d-flex gap-3 mt-2">
              {/* Avatar */}
              <div className="activity-avatar">
                <img src={profileIc} alt="logo" />
              </div>

              {/* Content */}
              <div className="flex-grow-1">
                <div className="fs-14 fw-700 textcolor">
                  To {activity.receipent ?? "-"}{" "}
                  {/* <span className="fs-12 fw-400 textltcolor">
                    &lt;{activity.toEmail}&gt;
                  </span> */}
                </div>

                {
                  <div className="fs-12 fw-400 textltcolor">
                    cc{" "}
                    <span className="fs-12 fw-600 textltcolor">
                      {activity.cc ?? "-"}
                    </span>
                  </div>
                }

                <div className="activity-title">{activity.subject ?? "-"}</div>

                <div className="activity-desc">{}</div>
              </div>
            </div>
          </div>
        ))
      )}
      {activities.length < totalCount && (
        <div className="text-center mt-3">
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={handleLoadMore}
            disabled={loading}
          >
            {loading ? "Loading..." : "More"}
          </button>
        </div>
      )}
    </div>
  );
}
